import { ITEM_TYPES } from '@wix/advanced-seo-utils';
import { SITE_LEVEL_PAGE_ID } from '../../consts';
export const getSubtitles = _ref => {
  let {
    groupData,
    scannedPagesAmount,
    totalPagesToScan,
    t
  } = _ref;
  return groupData.itemType !== ITEM_TYPES.STATIC_PAGE_V2 && groupData.pageId !== SITE_LEVEL_PAGE_ID ? scannedPagesAmount < totalPagesToScan ? t('accessibility-wizard.groups-list.subtitles.scan-in-process', {
    scanned: scannedPagesAmount,
    total: totalPagesToScan
  }) : t('accessibility-wizard.groups-list.subtitles.scan-in-process.finished', {
    total: totalPagesToScan
  }) : undefined;
};
//# sourceMappingURL=get-subtitles.js.map